import React from "react";
import LoadingSpinner from "./components/LoadingSpinner";
import { useAuth } from "./context/AuthContext";
import { Routes, Route } from "react-router-dom";
import ChatBrandPage from "./pages/ChatBrandPage";
import Login from "./pages/Login/index";
import LandingPage from "./pages/landingpageNew";
import Performance from "./pages/performance";
import TokenConsumptionPage from "./pages/TokenConsumption";
import Onboarding from "./pages/onboarding";
import RequireAuth from "./context/RequireAuth";
import RequireAgentAccess from "./context/RequireAgentAccess";
import RequireAdminAccess from "./context/RequireAdminAccess";
import ContractPerformance from "./pages/ContractDashboard/ContractPerformance";
import SupplierHealth from "./pages/ContractDashboard/SupplierHealth";
import NotFound from "./pages/NotFound";
import PrEfficiency from "./pages/ContractDashboard/PrEfficiency";
import ProcurementHealth from "./pages/ContractDashboard/ProcurementHealth";
import FeedbackPage from "./pages/Feedback";
import AppPage from "./pages/AppPage";
import UserRolesPage from "./pages/UserRoles";
import AgentManagementPage from "./pages/AgentManagement";
import AgentLookupManagementPage from "./pages/AgentLookupManagement";
import SkillGapAssessment from "./pages/SkillGapAssessment";
import AgentPage from "./pages/AgentPage";
import ProcurementDashboard from "./pages/ProcurementDashboard";

export default function App() {
  const { inProgress } = useAuth();
  const authInitializing = inProgress !== "none"; // MSAL interaction in progress
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route
        path="/landing"
        element={
          <RequireAuth>
            {authInitializing ? (
              <LoadingSpinner fullscreen label="Preparing secure session..." />
            ) : (
              <LandingPage />
            )}
          </RequireAuth>
        }
      />
      <Route
        path="/chat/:identifier"
        element={
          <RequireAuth>
            {authInitializing ? (
              <LoadingSpinner fullscreen label="Preparing secure session..." />
            ) : (
              <RequireAgentAccess>
                <ChatBrandPage />
              </RequireAgentAccess>
            )}
          </RequireAuth>
        }
      />
      <Route
        path="/appPage"
        element={
          <RequireAuth>
            {authInitializing ? (
              <LoadingSpinner fullscreen label="Preparing secure session..." />
            ) : (
              <RequireAgentAccess>
                <AppPage title="Accellor GenAI for Healthcare" />
              </RequireAgentAccess>
            )}
          </RequireAuth>
        }
      />
      <Route
        path="/performance"
        element={
          <RequireAuth>
            {authInitializing ? (
              <LoadingSpinner fullscreen label="Preparing secure session..." />
            ) : (
              <Performance />
            )}
          </RequireAuth>
        }
      />
      <Route
        path="/tokenconsumption"
        element={
          <RequireAuth>
            {authInitializing ? (
              <LoadingSpinner fullscreen label="Preparing secure session..." />
            ) : (
              <TokenConsumptionPage />
            )}
          </RequireAuth>
        }
      />
      <Route
        path="/onboarding"
        element={
          <RequireAuth>
            {authInitializing ? (
              <LoadingSpinner fullscreen label="Preparing secure session..." />
            ) : (
              <Onboarding />
            )}
          </RequireAuth>
        }
      />
      <Route
        path="/contract-performance"
        element={
          <RequireAuth>
            {authInitializing ? (
              <LoadingSpinner fullscreen label="Preparing secure session..." />
            ) : (
              <ContractPerformance />
            )}
          </RequireAuth>
        }
      />
      <Route
        path="/supplier-health"
        element={
          <RequireAuth>
            {authInitializing ? (
              <LoadingSpinner fullscreen label="Preparing secure session..." />
            ) : (
              <SupplierHealth />
            )}
          </RequireAuth>
        }
      />
      <Route
        path="/pr-efficiency"
        element={
          <RequireAuth>
            {authInitializing ? (
              <LoadingSpinner fullscreen label="Preparing secure session..." />
            ) : (
              <PrEfficiency />
            )}
          </RequireAuth>
        }
      />
      <Route
        path="/procurement-health"
        element={
          <RequireAuth>
            {authInitializing ? (
              <LoadingSpinner fullscreen label="Preparing secure session..." />
            ) : (
              <ProcurementHealth />
            )}
          </RequireAuth>
        }
      />
      <Route
        path="/procurement-dashboard/*"
        element={
          <RequireAuth>
            {authInitializing ? (
              <LoadingSpinner fullscreen label="Preparing secure session..." />
            ) : (
              <ProcurementDashboard />
            )}
          </RequireAuth>
        }
      />
      <Route
        path="/feedback"
        element={
          <RequireAuth>
            {authInitializing ? (
              <LoadingSpinner fullscreen label="Preparing secure session..." />
            ) : (
              <FeedbackPage />
            )}
          </RequireAuth>
        }
      />
      <Route
        path="/user-management"
        element={
          <RequireAuth>
            {authInitializing ? (
              <LoadingSpinner fullscreen label="Preparing secure session..." />
            ) : (
              <RequireAdminAccess>
                <UserRolesPage />
              </RequireAdminAccess>
            )}
          </RequireAuth>
        }
      />
      <Route
        path="/agent-management"
        element={
          <RequireAuth>
            {authInitializing ? (
              <LoadingSpinner fullscreen label="Preparing secure session..." />
            ) : (
              <RequireAdminAccess>
                <AgentManagementPage />
              </RequireAdminAccess>
            )}
          </RequireAuth>
        }
      />
      <Route
        path="/agent-lookup-management"
        element={
          <RequireAuth>
            {authInitializing ? (
              <LoadingSpinner fullscreen label="Preparing secure session..." />
            ) : (
              <RequireAdminAccess>
                <AgentLookupManagementPage />
              </RequireAdminAccess>
            )}
          </RequireAuth>
        }
      />
      <Route
        path="/skill-gap-assessment"
        element={
          <RequireAuth>
            {authInitializing ? (
              <LoadingSpinner fullscreen label="Preparing secure session..." />
            ) : (
              <SkillGapAssessment />
            )}
          </RequireAuth>
        }
      />
      <Route
        path="/agents/:agentFrameworkName/*"
        element={
          <RequireAuth>
            {authInitializing ? (
              <LoadingSpinner fullscreen label="Preparing secure session..." />
            ) : (
              <RequireAgentAccess>
                <AgentPage />
              </RequireAgentAccess>
            )}
          </RequireAuth>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
